export enum RoutingFlowType {
  CASE_RATE_RENEWAL = "CASE_RATE_RENEWAL",
  CHECK_IN_EXPERIENCE = "CHECK_IN_EXPERIENCE",
  JOURNEY_CHANGE = "JOURNEY_CHANGE"
}
